// extracted by mini-css-extract-plugin
module.exports = {"link":"_3BKA3","root":"FzytT","label":"vC3ww"};